import { ApiService } from "@/services/api/ApiService";
import type {
  AgentMailbox,
  AgentMailboxSelfProvisionInput,
  AgentMailboxTestResult,
  AgentMailboxUpdateInput,
  MailboxConversationDetail,
  MailboxConversationListParams,
  MailboxConversationListResult,
} from "@/types/agent-mailboxes";

class AgentMailboxSelfService {
  async update(agentId: string, input: AgentMailboxUpdateInput): Promise<void> {
    await ApiService.invoke({
      resource: "agent-mailboxes-self",
      action: "update",
      data: { agentId, ...input },
    });
  }

  async deprovision(agentId: string): Promise<void> {
    await ApiService.invoke({
      resource: "agent-mailboxes-self",
      action: "delete",
      data: { agentId },
    });
  }

  async provision(agentId: string, input?: AgentMailboxSelfProvisionInput): Promise<AgentMailbox> {
    const res = await ApiService.invoke<any>({
      resource: "agent-mailboxes-self",
      action: "provision",
      data: { agentId, ...input },
    });
    return res?.data ?? res;
  }

  async sendTest(agentId: string): Promise<AgentMailboxTestResult> {
    const res = await ApiService.invoke<any>({
      resource: "agent-mailboxes-self",
      action: "test",
      data: { agentId },
    });
    return res?.data ?? res;
  }

  async listConversations(
    agentId: string,
    params?: MailboxConversationListParams,
  ): Promise<MailboxConversationListResult> {
    const res = await ApiService.invoke<any>({
      resource: "agent-mailboxes-self",
      action: "conversations",
      data: { agentId, ...params },
    });
    return res?.data ?? res;
  }

  async getConversation(agentId: string, conversationId: string): Promise<MailboxConversationDetail> {
    const res = await ApiService.invoke<any>({
      resource: "agent-mailboxes-self",
      action: "conversation-detail",
      data: { agentId, conversationId },
    });
    return res?.data ?? res;
  }

  async sendReply(agentId: string, conversationId: string, bodyText: string): Promise<void> {
    await ApiService.invoke({
      resource: "agent-mailboxes-self",
      action: "reply",
      data: { agentId, conversationId, body_text: bodyText },
    });
  }
}

export const agentMailboxSelfService = new AgentMailboxSelfService();
